mutation CreateEmailChangeRequest($input: CreateEmailChangeRequestInput!) {
  newEmail: createEmailChangeRequest(input: $input)
}
